import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Subject, SubjectNew, SubjectUpdate } from '../../_objects/subject';
import { HttpService } from '../http.service';
import { SubjectContractService } from '../interfaces/subject-contract.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class SubjectOnlineService extends HttpService implements SubjectContractService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // SB01 GET /api/v1/subjects
  getSubjects(subjectModelId?: string, enabledOnly?: boolean): Observable<Subject[]> {
    const endpoint = super.getEndpoint('subjects');

    let httpParams = new HttpParams();
    if (subjectModelId) {
      httpParams = httpParams.set('md', subjectModelId);
    }
    if (enabledOnly !== null && enabledOnly !== undefined) {
      httpParams = httpParams.set('enabledOnly', String(enabledOnly));
    }

    return this.http.get<Subject[]>(endpoint,
      { withCredentials: super.getWithCredentialsOption(), params: httpParams })
      .pipe(map(response => response as Subject[]));
  }

  // SB02 GET /api/v1/subjects/{subjectId}
  getSubject(id: string, version?: number): Observable<Subject> {
    const endpoint = super.getEndpoint('subjects', id);

    let httpParams = new HttpParams();
    if (version !== null && version !== undefined) {
      httpParams = httpParams.set('version', String(version));
    }

    return this.http.get<Subject>(endpoint,
      { withCredentials: super.getWithCredentialsOption(), params: httpParams })
      .pipe(map(response => response as Subject));
  }

  // SB03 POST /api/v1/subjects
  addSubject(subject: SubjectNew): Observable<Subject> {
    const endpoint = super.getEndpoint('subjects');

    return this.http.post<Subject>(endpoint, subject,
      { withCredentials: super.getWithCredentialsOption() })
      .pipe(map(response => response as Subject));
  }

  // SB04 PUT /api/v1/subjects/{subjectId}
  updateSubject(subject: SubjectUpdate): Observable<Subject> {
    const endpoint = super.getEndpoint('subjects', subject.id);

    return this.http.put<Subject>(endpoint, subject,
      { withCredentials: super.getWithCredentialsOption() })
      .pipe(map(response => response as Subject));
  }

  // SB05 DELETE /api/v1/subjects/{subjectId}
  deleteSubject(id: string): Observable<Subject> {
    const endpoint = super.getEndpoint('subjects', id);

    return this.http.delete<Subject>(endpoint,
      { withCredentials: super.getWithCredentialsOption() })
      .pipe(map(response => response as Subject));
  }
}
